import React from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";

const Bar = styled.div`
  position: fixed; left: 0; right: 0; bottom: 0; z-index: 1100;
  display: none; /* hidden on desktop */
  @media (max-width: ${({theme})=>theme.breakpoints.md}) { display: block; }
  background: linear-gradient(90deg, ${({theme})=>theme.colors.gradient.from}, ${({theme})=>theme.colors.gradient.to});
  color: white; padding: 12px 16px;
  a{ display:flex; align-items:center; justify-content:center; gap:10px; font-weight:800; }
`;

export default function MobileBookBar(){
  const { pathname } = useLocation();
  if (pathname === "/checkout") return null;
  return (
    <Bar>
      <Link to="/booking"><FaCalendarAlt /> Book for $225 • Free overnight</Link>
    </Bar>
  );
}
